import { render, staticRenderFns } from "./BookingPresetFormMinimal.vue?vue&type=template&id=b78f5a3c&scoped=true&"
import script from "./BookingPresetFormMinimal.vue?vue&type=script&lang=js&"
export * from "./BookingPresetFormMinimal.vue?vue&type=script&lang=js&"
import style0 from "./BookingPresetFormMinimal.vue?vue&type=style&index=0&id=b78f5a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78f5a3c",
  null
  
)

export default component.exports